/**
 * Utility functions for affiliate click tracking
 */

// Helper to set a cookie with security flags
export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Lax;Secure";
};

// Helper to get a cookie value by name
export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// Initialize tracking on page load
export const initTracking = () => {
  // Check standard query parameters
  const urlParams = new URLSearchParams(window.location.search);
  
  // Also check hash-based parameters if using HashRouter (e.g., /#/?sub1=123)
  const hashString = window.location.hash.split('?')[1];
  const hashParams = new URLSearchParams(hashString || '');
  
  const paramsToCheck = ['sub1', 'transaction_id', 'aff_sub', 'click_id'];
  let trackingId = null;

  // Search for the first matching parameter in both search and hash queries
  for (const param of paramsToCheck) {
    if (urlParams.has(param)) {
      trackingId = urlParams.get(param);
      break;
    }
    if (hashParams.has(param)) {
      trackingId = hashParams.get(param);
      break;
    }
  }

  // If a tracking parameter is found, save it to both localStorage and Cookie
  if (trackingId) {
    localStorage.setItem('glitchy_tx_id', trackingId);
    setCookie('glitchy_tx_id', trackingId, 30);
  }
};

// Global helper to retrieve the stored tracking ID
export const getTrackingId = () => {
  // 1. Try to get from localStorage
  const localId = localStorage.getItem('glitchy_tx_id');
  if (localId) return localId;
  
  // 2. Try to get from Cookie (fallback)
  const cookieId = getCookie('glitchy_tx_id');
  if (cookieId) {
    // Sync it back to local storage
    localStorage.setItem('glitchy_tx_id', cookieId);
    return cookieId;
  }
  
  // 3. Default fallback if none exists
  return 'direct_organic';
};